<div class="dialog" fxLayout="column">

  <div mat-dialog-header>
    <div class="dialog-title" fxLayout="row" fxLayoutAlign="space-between end">
      <div fxLayout="row" fxLayoutGap="10px">
        <mat-icon>create</mat-icon>
        <h1 *ngIf="!isAdded">{{'プロジェクト：編集' | translate}}</h1>
        <h1 *ngIf="!!isAdded">{{'プロジェクト：追加' | translate}}</h1>
      </div>

      <div fxLayout="row" fxLayoutGap="8px">
        <button *ngIf="userType==USER_TYPE_ADMIN || userType==USER_TYPE_MASTER" mat-raised-button color="primary" (click)="addProject()" [disabled]="!projectFormGroup.valid || !languages.length">
          <mat-icon>add</mat-icon>
          <span *ngIf="!isAdded">{{'更新' | translate}}</span>
          <span *ngIf="!!isAdded">{{'追加' | translate}}</span>
        </button>
        <button mat-button (click)="onNoClick()">
          <mat-icon>clear</mat-icon>
        </button>
      </div>
    </div>
  </div>

  <div mat-dialog-content fxFlex="600px" style="overflow: auto;">
    <form class="form" [formGroup]="projectFormGroup">
      <div class="dialog-body" fxLayout="column" fxLayoutGap="24px">
        <mat-form-field>
          <mat-label floatLabel="always">ID</mat-label>
          <input matInput *ngIf="!isAdded" placeholder="ID" id="projectId" formControlName="projectId" readonly>
          <input matInput *ngIf="!!isAdded" placeholder="ID" id="projectId" formControlName="projectId">
          <mat-error *ngIf="projectIdControl.invalid">{{ getErrorMessageToProjectId() }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label floatLabel="always">{{'名称' | translate}}</mat-label>
          <input matInput placeholder="{{'名称' | translate}}" id="projectName" formControlName="projectName">
          <mat-error *ngIf="projectNameControl.invalid">{{ getErrorMessageToProjectName() }}</mat-error>
        </mat-form-field>

        <mat-form-field>
          <mat-label floatLabel="always">{{'備考' | translate}}</mat-label>
          <input matInput placeholder="{{'備考' | translate}}" id="projectDesc" formControlName="projectDesc">
        </mat-form-field>

        <div fxLayout="row" fxLayoutGap="20px">
          <mat-form-field fxFlex="20%" floatLabel="always">
            <mat-label>{{'施設登録限度数' | translate}}</mat-label>
            <input matInput type="number" [readonly]="!adminUser" placeholder="{{'施設登録限度数' | translate}}"
              id="facilityRegistrationLimit" formControlName="facilityRegistrationLimit">
            <mat-error *ngIf="facilityRegistrationLimitControl.invalid">{{ getErrorMessageToFacilityRegistrationLimit()
              }}</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="40%" floatLabel="always">
            <mat-label>{{'番号入力タイプ' | translate}}</mat-label>
            <mat-select placeholder="{{'選択してください' | translate}}" id="keypadType" formControlName="keypadType">
              <mat-option *ngFor="let keypadType of keypadTypes" [value]="keypadType">{{ keypadType | typeOfKeypad
                }}</mat-option>
            </mat-select>
            <mat-error *ngIf="keypadTypeControl.invalid">{{ getErrorMessageToKeypadType() }}</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="40%" floatLabel="always" >
            <mat-label>{{'プロジェクト基本言語' | translate}}</mat-label>
            <mat-select placeholder="{{'選択してください' | translate}}" id="projectBaseLang" formControlName="projectBaseLang"  (selectionChange)="changeProjectBaseLang()">
              <mat-option *ngFor="let projectBaseLang of projectBaseLangs; let i = index" [value]="projectBaseLang" [value]="projectBaseLang">{{
                projectBaseLang | typeOfTransBaseLang }}</mat-option>
            </mat-select>
            <mat-error *ngIf="projectBaseLangControl.invalid">{{ getErrorMessageToProjectBaseLang() }}</mat-error>
          </mat-form-field>
          <mat-form-field fxFlex="40%" floatLabel="always" *ngIf="projectBaseLangControl.value === 'ja'">
            <mat-label>{{'翻訳基本言語' | translate}}</mat-label>
            <mat-select placeholder="{{'選択してください' | translate}}" id="transBaseLang" formControlName="transBaseLang"
              (selectionChange)="changeTransBaseLang()">
              <mat-option *ngFor="let transBaseLang of transBaseLangs" [value]="transBaseLang">{{ transBaseLang |
                typeOfTransBaseLang }}</mat-option>
            </mat-select>
            <mat-error *ngIf="transBaseLangControl.invalid">{{ getErrorMessageToTransBaseLang() }}</mat-error>
          </mat-form-field>
        </div>
        <div class="use-trans-base" fxLayout="row" fxLayoutGap="20px" *ngIf="projectBaseLangControl.value === 'ja'">
          <div fxFlex="33%" floatLabel="always">
          </div>
          <div fxFlex="40%" floatLabel="always">
          </div>
          <div fxFlex="27%" floatLabel="always">
            <div class="supplement">▼{{ '次の言語は翻訳基本言語を介さずに直接翻訳されます。' | translate }}<br>　{{ '翻訳基本言語から翻訳させたい場合はチェックを入れてください。' | translate }}</div>
            <mat-checkbox formControlName="useTransBaseLangKo" color="primary">{{ '韓国語' | translate }}</mat-checkbox><br>
            <mat-checkbox formControlName="useTransBaseLangYueHK" color="primary">{{ '中国語（香港）' | translate }}</mat-checkbox>
            <mat-checkbox formControlName="useTransBaseLangZhCN" color="primary">{{ '中国語（簡体）' | translate }}</mat-checkbox>
            <mat-checkbox formControlName="useTransBaseLangZhTW" color="primary">{{ '中国語（繁体）' | translate }}</mat-checkbox>
          </div>
        </div>
        <div class="language-list" fxLayout="column">
          <div class="language-list-title" fxLayout="row" fxLayoutAlign="space-between end">
            <h3>{{'使用言語' | translate}}</h3>
            <button mat-stroked-button (click)="openSelectLanguagesDialog()">
              <mat-icon>add</mat-icon>
              <span>{{'言語追加' | translate}}</span>
            </button>
          </div>
          <p>{{'※最上段の言語が優先言語として登録されます。' | translate}}</p>

          <table>
            <thead>
              <tr>
                <th>{{'言語コード' | translate}}</th>
                <th>{{'名称' | translate}}</th>
                <th>{{'話者' | translate}}</th>
                <th>{{'削除' | translate}}</th>
              </tr>
            </thead>
            <tbody cdkDropList class="cdk-table" (cdkDropListDropped)="onDropLanguage($event)">
              <tr *ngFor="let language of languages" cdkDrag cdkDragLockAxis="y">
                <td>{{ language.lang_code }}</td>
                <td>{{ currentLang == 'en' ?  (language.lang_name_en ? language.lang_name_en : (language.lang_name | translate)): language.lang_name}}</td>
                <td>
                  <mat-select id="voiceName" [value]="getSelectedTtsVoice(language.lang_code)"
                    (selectionChange)="changeSelectedTtsVoice(language.lang_code, $event)">
                    <ng-container *ngFor="let tts_voice_code of language.tts_voice_codes; let i=index">
                      <mat-option *ngIf="tts_voice_code.code !== ''" [value]="tts_voice_code.code">
                        {{ tts_voice_code.name | translate }}
                      </mat-option>
                    </ng-container>
                  </mat-select>
                </td>
                <td>
                  <button mat-stroked-button color="warn" (click)="deleteLanguage(language.id!)"
                    [disabled]="language.id=='ja' || (language.id==getSelectTransBaseLang()&&languages.length>2)">
                    <mat-icon>clear</mat-icon>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </form>
  </div>


</div>